import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { getOtherOptionsFromWindow, createRegxpPatternFromWildcardedName } from "../utils";
import { OPT_IN_EVENT } from "../types";
import { getUserDecision } from "../others";
/**
 * `window.consentApi.consent`: Check if a given technical information (e.g. HTTP Cookie, LocalStorage, ...) has a consent:
 *
 * - When a technical information exists in defined cookies, the Promise is only resolved after given consent
 * - When no technical information exists, the Promise is immediate resolved
 *
 * Example (ES5):
 * ```js
 * (window.consentApi && window.consentApi.consent("http", "_twitter_sess", ".twitter.com") || Promise.resolve()).then(function() {
 *     console.log("Consent for Twitter embed given, do something...!");
 * });
 * ```
 *
 * Example (ES6, Babel, TS):
 * ```js
 * (window.consentApi?.consent("http", "_twitter_sess", ".twitter.com") || Promise.resolve()).then(() => {
 *     console.log("Consent for Twitter embed given, do something...!");
 * });
 * ```
 */

function consent(type, name, host) {
  return new Promise(function (resolve) {
    // Find matching cookie
    var found;

    var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
        groups = _getOtherOptionsFromW.groups;

    var allCookies = groups.map(function (_ref) {
      var items = _ref.items;
      return items;
    }).flat();

    var _iterator = _createForOfIteratorHelper(allCookies),
        _step;

    try {
      loop1: for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var row = _step.value;
        var technicalDefinitions = row.technicalDefinitions;

        if (technicalDefinitions !== null && technicalDefinitions !== void 0 && technicalDefinitions.length) {
          // Check if technical information matches
          var _iterator2 = _createForOfIteratorHelper(technicalDefinitions),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var td = _step2.value;
              var regexp = createRegxpPatternFromWildcardedName(td.name);

              if (td.type === type && (td.name === name || name.match(regexp)) && td.host === host) {
                found = row;
                break loop1;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (found) {
      // Check if consent is already given
      var already = getUserDecision();

      if (already) {
        var consentCookieIds = Object.values(already.consent).flat();

        if (consentCookieIds.indexOf(found.id) > -1) {
          resolve();
        }
      } else {
        // Wait for consent
        document.addEventListener(OPT_IN_EVENT, /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
            var cookie;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    cookie = _ref2.detail.cookie;

                    if (cookie === found) {
                      resolve();
                    }

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }());
      }
    } else {
      resolve();
    }
  });
}

export { consent };